let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hU44e")).then(() => parcelRequire('dp9p6'));